export var getAppNameFromAppString = function (appName) {
    return appName.split('/')[0];
};
//# sourceMappingURL=appTester.js.mapexport var getAppNameFromAppString = function (appName) {
    return appName.split('/')[0];
};
//# sourceMappingURL=appTester.js.map